<template>
  <div class="bg-white p-6 border rounded-xl shadow-sm transition-all duration-200 hover:shadow-md relative"
       :class="{
         'border-red-300 bg-red-50': !localItem.status,
         'border-green-300 bg-green-50': localItem.status
       }">
    <div class="flex items-center gap-1 text-sm text-gray-500 mb-3">
      <span class="px-2 py-1 bg-gray-100 rounded">
        {{ sectionTitle }}
      </span>
    </div>

    <div class="space-y-4">
      <h4 class="text-lg font-semibold text-gray-800 pr-8">
        {{ localItem.description }}
      </h4>

      <div class="bg-white rounded-lg space-y-4 w-full overflow-x-hidden">
        <div v-if="getRadioOptions(localItem).length" class="relative">
          <div class="flex flex-wrap gap-2 sm:gap-4">
            <template v-for="option in getRadioOptions(localItem)" :key="option.id">
              <label class="relative flex items-center group cursor-pointer">
                <input
                  type="radio"
                  :name="'status-' + localItem.id"
                  :value="option.text"
                  v-model="localItem.status"
                  @change="emitChanges"
                  class="peer sr-only"
                />
                <div class="p-2 sm:p-4 border-2 rounded-lg 
                          peer-checked:border-blue-500 peer-checked:bg-blue-100 
                          peer-checked:shadow-md
                          transition-all duration-200 hover:border-blue-200
                          hover:bg-gray-50">
                  <span class="font-medium text-gray-700 peer-checked:text-blue-700
                            peer-checked:font-bold whitespace-nowrap">
                    {{ option.text }}
                  </span>
                </div>
              </label>
            </template>
          </div>
          
          <!-- Clear selection button -->
          <button 
            v-if="localItem.status" 
            @click="clearSelection"
            class="mt-2 text-sm text-gray-500 hover:text-red-600 flex items-center gap-1 transition-all duration-200"
            type="button"
          >
            <span class="material-icons text-sm">close</span>
            Limpiar selección
          </button>
        </div>

        <div v-if="getInputOptions(localItem).length" class="flex flex-col gap-2">
          <template v-for="option in getInputOptions(localItem)" :key="option.id">
            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-2 w-full">
              <label class="font-medium text-gray-700 min-w-[80px] text-sm sm:text-base">
                {{ option.text }}:
              </label>
              <div class="relative flex-1 w-full sm:w-auto">
                <input
                  type="text"
                  v-model="option.value"
                  @input="emitChanges"
                  class="w-full sm:w-32 p-2 border-2 rounded-lg focus:ring-2 focus:ring-blue-300 
                         focus:border-blue-500 outline-none transition-all duration-200 text-sm sm:text-base"
                  :placeholder="option.unit"
                />
                <span class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                  {{ option.unit }}
                </span>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="mt-4">
        <textarea
          v-model="localItem.comments"
          @input="emitChanges"
          placeholder="Add comments..."
          class="w-full p-3 border-2 rounded-lg bg-gray-50 placeholder-gray-400
                 focus:ring-2 focus:ring-blue-300 focus:border-blue-500 outline-none"
          rows="2"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    sectionTitle: String,
  },
  data() {
    return {
      localItem: { ...this.item }
    };
  },
  watch: {
    item(newVal) {
      this.localItem = { ...newVal };
    }
  },
  methods: {
    getRadioOptions(item) {
      return item.options.filter(opt => opt.type === 'radio' || !opt.type);
    },
    getInputOptions(item) {
      return item.options.filter(opt => opt.type === 'input');
    },
    emitChanges() {
      this.$emit('update-item', this.localItem);
    },
    clearSelection() {
      this.localItem.status = '';
      this.emitChanges();
    }
  }
};
</script>
